/**
 * Delete Confirm Modal Component
 * Reusable modal for confirming delete actions
 */

import React from 'react';
import { ConfirmDialog } from '../../common/ConfirmDialog';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  title: string;
  message: string;
  isLoading?: boolean;
  confirmText?: string;
  cancelText?: string;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isLoading = false,
  confirmText = 'Delete',
  cancelText = 'Cancel',
}) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      isLoading={isLoading}
      confirmText={confirmText}
      cancelText={cancelText}
      tone="danger"
    />
  );
};
